module.exports = "/_next/static/images/game-1-phone-attachment-house-425d6696895a67460c45ecf4cda46168.jpg";